import { render, staticRenderFns } from "./FullScreenAccordionItem.vue?vue&type=template&id=2866b2e8&scoped=true"
import script from "./FullScreenAccordionItem.vue?vue&type=script&lang=js"
export * from "./FullScreenAccordionItem.vue?vue&type=script&lang=js"
import style0 from "./FullScreenAccordionItem.vue?vue&type=style&index=0&id=2866b2e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2866b2e8",
  null
  
)

export default component.exports